"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrcErcStandingsAndResults1Schema = void 0;
exports.WrcErcStandingsAndResults1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/wrc-erc-standings-and-results/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "WrcErcStandingsAndResults1",
    "description": "The official timing provider of WRC/ERC is providing us with a custom script that we can initiate based on an ID from their master system.",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:wrc-erc-standings-and-results:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "competition": {
                    "type": "string",
                    "enum": [
                        "wrc",
                        "erc"
                    ],
                    "description": "Option to select either WRC or ERC."
                },
                "idSas": {
                    "type": "number",
                    "description": "The SAS ID associated to a given event."
                }
            },
            "required": [
                "competition",
                "idSas"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy93cmMtZXJjLXN0YW5kaW5ncy1hbmQtcmVzdWx0cy8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGdDQUFnQyxHQUFHO0lBQzlDLEtBQUssRUFBRSxrR0FBa0c7SUFDekcsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsNEJBQTRCO0lBQ3JDLGFBQWEsRUFBRSw0SUFBNEk7SUFDM0osTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sMERBQTBEO2FBQzNEO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixhQUFhLEVBQUU7b0JBQ2IsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLE1BQU0sRUFBRTt3QkFDTixLQUFLO3dCQUNMLEtBQUs7cUJBQ047b0JBQ0QsYUFBYSxFQUFFLHFDQUFxQztpQkFDckQ7Z0JBQ0QsT0FBTyxFQUFFO29CQUNQLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUseUNBQXlDO2lCQUN6RDthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLGFBQWE7Z0JBQ2IsT0FBTzthQUNSO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=